import { render, staticRenderFns } from "./TableAddOrders.vue?vue&type=template&id=dc5d3392&scoped=true"
import script from "./TableAddOrders.vue?vue&type=script&lang=js"
export * from "./TableAddOrders.vue?vue&type=script&lang=js"
import style0 from "./TableAddOrders.vue?vue&type=style&index=0&id=dc5d3392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5d3392",
  null
  
)

export default component.exports